import { render, staticRenderFns } from "./batchAddFriendRecord.vue?vue&type=template&id=08e724d6&scoped=true"
import script from "./batchAddFriendRecord.vue?vue&type=script&lang=js"
export * from "./batchAddFriendRecord.vue?vue&type=script&lang=js"
import style0 from "./batchAddFriendRecord.vue?vue&type=style&index=0&id=08e724d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e724d6",
  null
  
)

export default component.exports